/* Vermeulen: menu opent bij hover (zoals Symmetry) */
(function(){
  function init(){
    if (!window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('.header__inline-menu details').forEach(function(d){
      var li=d.closest('li')||d, t;
      li.addEventListener('mouseenter',function(){ clearTimeout(t); document.querySelectorAll('.header__inline-menu details[open]').forEach(function(o){ if(o!==d){ o.removeAttribute('open'); var s=o.querySelector('summary'); s&&s.setAttribute('aria-expanded','false'); } }); d.setAttribute('open',''); var s=d.querySelector('summary'); s&&s.setAttribute('aria-expanded','true'); });
      li.addEventListener('mouseleave',function(){ t=setTimeout(function(){ d.removeAttribute('open'); var s=d.querySelector('summary'); s&&s.setAttribute('aria-expanded','false'); },150); });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
/* Vermeulen: zoeklaag (zoals Symmetry) */
(function(){
  function money(c){ return '€'+(c/100).toFixed(2).replace('.',','); }
  function card(p){
    var v=p.variants&&p.variants[0]||{}; var price=Math.round(parseFloat(p.price)*100); var cmp=p.compare_at_price_max?Math.round(parseFloat(p.compare_at_price_max)*100):0;
    var sale=cmp>price; var pct=sale?Math.round((cmp-price)*100/cmp):0;
    var img=p.featured_image&&p.featured_image.url?p.featured_image.url+(p.featured_image.url.indexOf('?')>-1?'&':'?')+'width=500':'';
    return '<div class="vm-card"><a class="vm-card__media" href="'+p.url+'">'+(sale?'<span class="vm-card__badge">-'+pct+'%</span>':'')+(img?'<img src="'+img+'" alt="" loading="lazy">':'')+'</a><div class="vm-card__info"><a class="vm-card__title" href="'+p.url+'">'+p.title+'</a><div class="vm-card__price"><span>'+money(price)+'</span>'+(sale?'<s>'+money(cmp)+'</s><span class="vm-card__sale">Aanbieding</span>':'')+'</div></div></div>';
  }
  function init(){
    var o=document.getElementById('VmSearchOverlay'); if(!o) return;
    var input=o.querySelector('[data-vm-so-input]'), res=o.querySelector('[data-vm-so-results]'), t, last='';
    function open(){ o.classList.add('is-open'); o.setAttribute('aria-hidden','false'); setTimeout(function(){ input.focus(); },300); }
    function close(){ o.classList.remove('is-open'); o.setAttribute('aria-hidden','true'); }
    document.addEventListener('click',function(e){
      var s=e.target.closest('.header__search summary, .header__icon--search, a[href$="/search"].header__icon');
      if(s && !e.target.closest('.vm-so')){ e.preventDefault(); e.stopPropagation(); open(); }
      if(e.target.closest('[data-vm-so-close]')){ e.preventDefault(); close(); }
    },true);
    document.addEventListener('keyup',function(e){ if(e.key==='Escape') close(); });
    input.addEventListener('input',function(){
      clearTimeout(t); var q=input.value.trim(); if(q===last) return; last=q;
      if(q.length<2){ res.innerHTML=''; return; }
      t=setTimeout(function(){
        fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function(r){return r.json();}).then(function(j){
            var ps=(j.resources&&j.resources.results&&j.resources.results.products)||[];
            res.innerHTML=ps.length?'<div class="vm-so__grid">'+ps.map(card).join('')+'</div><div class="vm-so__all"><a class="vm-btn" href="/search?type=product&q='+encodeURIComponent(q)+'">Bekijk alle resultaten</a></div>':'<p style="text-align:center">Geen resultaten</p>';
          });
      },250);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
/* Vermeulen: sliderkaarten even hoog als de eerste rij (zoals Symmetry) */
(function(){
  function fix(){
    document.querySelectorAll('.section-vm-featured-collection .vm-slider__track, .section-vm-related-products .vm-slider__track').forEach(function(t){
      var items=[].slice.call(t.children); if(!items.length) return;
      items.forEach(function(i){ i.style.height=''; });
      var w=t.clientWidth, first=items.filter(function(i){ var l=i.offsetLeft-t.scrollLeft; return l>=-5 && l<w-5; });
      first=items;
      var h=Math.max.apply(null,first.map(function(i){ return i.offsetHeight; }));
      if(h>0) items.forEach(function(i){ i.style.height=h+'px'; i.style.overflow='visible'; });
    });
  }
  window.addEventListener('load',fix); window.addEventListener('resize',function(){ clearTimeout(window.__vmfx); window.__vmfx=setTimeout(fix,200); });
})();
